import router from "@/router";

router.addRoute({
    path: "/hotel/sadmin/tool-tip",
    name: "ToolTip",
    component: () => import("./View.vue"),
});
